// 260507nrai: Own module so evaluation finishes (window.jQuery set) before migrate imports.
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
export { $ };
export default $;
